import React from 'react';
import { Hero } from '../Hero/Hero';

export const HowItWorks = () => {
  return (
    <div style={{ padding: 0, margin: 0, maxWidth: 'none' }}>
      <Hero slim title="How It Works" eyebrow="Data Guide" />

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '48px 40px 64px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32 }}>
          <a href="/data" className="btn-ghost" style={{ padding: '6px 14px', fontSize: 13, textDecoration: 'none' }}>
            ← Back to Data
          </a>
        </div>

        <section style={{ marginBottom: 32, paddingBottom: 24, borderBottom: '1px solid var(--border)' }}>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: 'var(--ink)' }}>
            Use the controls below to filter, explore, and export geofluid data from the GSF database.
          </p>
        </section>

        <div className="contribute-tips-panel">
          <h2 style={{ color: 'var(--navy)', fontSize: 18, fontWeight: 700, marginBottom: 10 }}>Basic Filters</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: 'var(--ink)', marginBottom: 24 }}>
            Narrow results by fluid type, country, or geology using the dropdown menus.
          </p>

          <h2 style={{ color: 'var(--navy)', fontSize: 18, fontWeight: 700, marginBottom: 10 }}>Advanced Filters</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: 'var(--ink)', marginBottom: 24 }}>
            Define element-level thresholds with custom operators ({'>'}, {'<'}, {'='}) and AND/OR logic for precise query composition.
          </p>

          <h2 style={{ color: 'var(--navy)', fontSize: 18, fontWeight: 700, marginBottom: 10 }}>Exporting Data</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: 'var(--ink)', marginBottom: 0 }}>
            Download your filtered dataset as a CSV or Excel file for direct use in research workflows.
          </p>
        </div>

        <div className="contribute-tips-panel" style={{ marginTop: 36 }}>
          <h2 style={{ color: 'var(--navy)', fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Data Overview</h2>
          <ul style={{ fontSize: 15, lineHeight: 1.7, color: 'var(--ink)', marginLeft: 20 }}>
            <li><strong>Location Information:</strong> Coordinates, depth, and country of origin for each sample.</li>
            <li><strong>Physical Parameters:</strong> Temperature, total dissolved solids (TDS), pH, salinity, conductivity, and Eh.</li>
            <li><strong>Geochemistry:</strong> Major and trace elements, expressed in ppm, across different types of fluids (geothermal, brines, hot springs, etc.).</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
